module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAaCAMAAACEqFxyAAAAb1BMVEUAAABmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmbw3/OPAAAAJHRSTlMACMMtJfbP1hjS7YccEwvx3byvNxC1pZxUPCB9x5WNeXFQQDPpkAYDAAAAvElEQVQoz23P2a6DIBRGYbRWLDjPtmfosN7/GUtMNi3quvrzBRJQ0uk+NP+dCotG1oYs0Jrz33OxBvPtAz/lOlrSj3YYmZrZs+Umc6b1HPOSmaA9a3qZBbXnC7nMXE7nk4GzD6oxcbcqNww+UwGJsrRFFNRPjCqlUJsitNJct1w4TknkETIyLh9e4HHAv9AccAfzAffICjhK63LHkrAm33K/vnv3ndLxjXg5BXUtkyprdpmru2KbOKixmXoDjWgUcDZqzscAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mima.png
// module id = ypQn
// module chunks = 1